export const getFooterPosts = state => state.footerPosts || [];
